import { post, postJson, get } from './axios'

const RESOURCE_BASE_PATH = '/members-api/public';

/*
 * 获取自己的会员卡列表
 * */
export const getScoresCardList = p => postJson(`${RESOURCE_BASE_PATH}/getScoresCardList`, p);

/*
 * 获取自己的会员卡等级列表
 * */
export const getScoresCardGradeList = p => post(`${RESOURCE_BASE_PATH}/getScoresCardGradeList`, p);

/*
 * 淘宝子店铺优惠券获取
 * */
export const getTBCouponList = p => postJson(`${RESOURCE_BASE_PATH}/getTBCouponList`, p);